import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { canAccessBotOperatorSurface, canAccessBotSurface, type Role } from '@/types/navigation';

/** Direct bot URLs use the same resolved predicate as the navigation registry.
 * Revoking access rerenders this guard immediately and ejects an open bot page
 * before any bot control can remain mounted. */
export function BotAccessRoute() {
  const role = (useAuthStore((s) => s.user?.role) ?? 'trader') as Role;
  const botAccess = useAuthStore((s) => s.user?.botAccess ?? false);
  return canAccessBotSurface(role, botAccess) ? <Outlet /> : <Navigate to="/dashboard" replace />;
}

export function BotsIndexRoute() {
  const role = (useAuthStore((s) => s.user?.role) ?? 'trader') as Role;
  const target = canAccessBotOperatorSurface(role) ? '/bots/vanilla' : '/bots/g9';
  return <Navigate to={target} replace />;
}

export function BotOperatorRoute() {
  const role = (useAuthStore((s) => s.user?.role) ?? 'trader') as Role;
  return canAccessBotOperatorSurface(role) ? <Outlet /> : <Navigate to="/bots/g9" replace />;
}
